import { Result, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { ERROR_TEXT } from '../constants/text';
import type { ApiError } from '../types/apiError';

interface QueryErrorStateProps {
  error?: unknown;
  onRetry?: () => void;
  title?: string;
  subTitle?: string;
}

const QueryErrorState = ({ error, onRetry, title, subTitle }: QueryErrorStateProps) => {
  const apiError = error as ApiError | undefined;
  const resolvedSubTitle = subTitle ?? apiError?.message ?? ERROR_TEXT.GENERIC_SUBTITLE;

  return (
    <div className="sa-p-6 sa-text-align-center">
      <Result
        status="error"
        title={title ?? ERROR_TEXT.GENERIC_TITLE}
        subTitle={resolvedSubTitle}
        extra={
          onRetry
            ? [
                <Button key="retry" type="primary" icon={<ReloadOutlined />} onClick={onRetry}>
                  {ERROR_TEXT.RETRY}
                </Button>,
              ]
            : undefined
        }
      />
    </div>
  );
};

export default QueryErrorState;
